export default "__VITE_ASSET__7W6dILyi__"